angular.module 'zc.commonApi'

.factory 'ClearanceItemSet', ($resource, $q, Api) ->
  URL = '/api/projects/:projectId/clearance_item_sets/:id'
  ClearanceItemSet = $resource Api.path(URL), { projectId: @projectId, id: @id },
    query:
      method: 'GET'
      isArray: false # Rails returns object instead of array
    save:
      method: 'POST'
      headers:
        'Content-Type': undefined
      transformRequest: (data) ->
        formData = new FormData()
        angular.forEach data, (val, key) ->
          formData.append key, val
        formData
    destroy:
      method: 'DELETE'
    update:
      method: 'PATCH'
    items:
      method: 'GET'
      url: "#{Api.path(URL)}/items"

  service =
    all: (params) ->
      $q (resolve, reject) ->
        ClearanceItemSet.query params, (res) ->
          resolve res.clearance_item_sets
        , (err) ->
          reject err

    find: (params) ->
      $q (resolve, reject) ->
        ClearanceItemSet.query params, (res) ->
          resolve res.clearance_item_set
        , (err) ->
          reject err

    getItems: (params) ->
      $q (resolve, reject) ->
        ClearanceItemSet.items params, (res) ->
          resolve res.clearance_items
        , (err) ->
          reject err

    create: (params, set) ->
      $q (resolve, reject) ->
        clearance_item_set = new ClearanceItemSet set
        clearance_item_set.$save(params)
        .then (res) ->
          resolve res.clearance_item_set
        , (err) ->
          reject err

    destroy: (params) ->
      $q (resolve, reject) ->
        ClearanceItemSet.destroy
          projectId: params.project_id
          id: params.id
        .$promise.then (res) ->
          resolve res
        , (err) ->
          reject err

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/clearance_item_set.service.coffee